import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Enquiry from './pages/Enquiry';
import Contact from './pages/Contact';
import './assets/css/plugins.css';
import './assets/css/style.css';
import './assets/css/services.css';
import './assets/css/contact.css';
import './assets/css/about.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Blog from './components/Blog/Blog';
import DestinationDetails from './components/Destination/DestinationDetails';
import BookDestination from './components/Destination/BookDestination';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import PaymentPage from './components/Payment/PaymentPage';

function App() {
  const [admin, setAdmin] = useState(null);

  const handleAdminLogin = (adminData) => {
    setAdmin(adminData);
  };

  const handleAdminLogout = () => {
    setAdmin(null);
  };

  // Protected Route Component
  const ProtectedRoute = ({ children }) => {
    return admin ? children : <Navigate to="/admin/login" />;
  };

  // Public Route Component (redirect to dashboard if already logged in)
  const PublicRoute = ({ children }) => {
    return !admin ? children : <Navigate to="/admin/dashboard" />;
  };

  return (
    <Router>
      <div className="vs-body">
        
        {!window.location.pathname.startsWith('/admin') && <Header />}
        <main className="main">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/destinationdetails" element={<DestinationDetails />} />
            <Route path="/bookdestination" element={<BookDestination />} />
            <Route path="/payment/:id" element={<PaymentPage />} />

            {/* Admin Routes */}
            <Route
              path="/admin/login"
              element={
                <PublicRoute>
                  <AdminLogin onLogin={handleAdminLogin} />
                </PublicRoute>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard admin={admin} onLogout={handleAdminLogout} />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        {!window.location.pathname.startsWith('/admin') && <Footer />}
      </div>
    </Router>
  );
}

export default App;